import { AbstractShapeToolHelper } from '../shared/tool-helpers/abstract-shape-tool-helper';

export class SingleClickShapeToolHelper extends AbstractShapeToolHelper {
  createShape() {
    this.startListening();
    void this.stopListening();
  }
}
